import { render, staticRenderFns } from "./insure.vue?vue&type=template&id=18d7424e&scoped=true"
import script from "./insure.vue?vue&type=script&lang=js"
export * from "./insure.vue?vue&type=script&lang=js"
import style0 from "./insure.vue?vue&type=style&index=0&id=18d7424e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d7424e",
  null
  
)

export default component.exports